import React, { FC } from 'react';

import { Divider, Stack, Typography } from '@mui/material';

interface Props {
  title?: string;
  description?: string;
  removeDividers?: boolean;
  children?: React.ReactNode;
}

// This component has an optional title and children to render inside of a SettingsCard component
export const SettingsCardSection: FC<Props> = ({ title, description, children, removeDividers = false }) => {
  return (
    <Stack gap={1}>
      {title && <Typography variant="subtitle1">{title}</Typography>}
      {description && <Typography color="text.secondary">{description}</Typography>}
      <Stack gap={1} divider={removeDividers ? null : <Divider />}>
        {children}
      </Stack>
    </Stack>
  );
};
